import { useTranslations } from 'next-intl'

import ReportCard from '~/components/blocks/ReportCard/ReportCard'

const MARKET_REPORTS_IMAGE = {
  _ref: 'image-f3a817f71dda4d12d19d36195f82f686c8ccfea5-298x200-png',
  _type: 'reference' as const,
}

const MarketReportsCard = () => {
  const t = useTranslations('articleContainer')

  return (
    <ReportCard
      _id="market-reports-banner"
      title={t('marketReportsBannerTitle')}
      subtitle={t('marketReportsBannerSubCopy')}
      leadImage={{ asset: MARKET_REPORTS_IMAGE }}
      isPdfType={false}
      slug=""
      primaryCategory={{ name: '', slug: '' }}
      variant="featurePanel"
      matchGridHeight={false}
      ctaText={t('marketReportsBannerCta')}
      ctaUrl="/market-reports"
    />
  )
}

export default MarketReportsCard
